<template>
  <div>
    <div class="main-div">
      <nav class="nav-container">
        <ul class="nav-logo">
          <li>
            <router-link v-bind:to="{ name: 'home'}">
              <img src="../images/coloredfinallogochanged.png" alt="logo" preload="auto" v-bind:class="{'img': showMenu}"/>
            </router-link>
          </li>
        </ul>
        <button aria-label="hamburger-menu" class="hamburger-button" v-on:click="showMenu = !showMenu" v-bind:class="{'hamburger-button-clicked': !showMenu}">
          <i class="fa fa-bars"></i>
        </button>
      </nav>
      <div class="menu-items" :class="{ 'safari-fix': isSafariLoginPage || isSafariTrendingPage }" v-bind:style="{transform: showMenu ? 'translateY(0)' : 'translateY(-100%)'}">
        <ul>
          <li>
            <a class="nav-elements" target="__blank" href="https://barbershoptalk.shop">Barbershop Talk Store</a>
          </li>

          <li>
            <router-link class="nav-elements nav-elements--picks" v-on:click="resetScrollDepth(); showMenu = false" v-bind:to="{ name: 'sniperPicksPage'}">
              <span class="nav-picks-row"><i class="fa fa-crosshairs" aria-hidden="true"></i> Under Sniper</span>
            </router-link>
          </li>

          <li>
            <router-link class="nav-elements" v-on:click="resetScrollDepth()" v-bind:to="{ name: 'theCommunity'}">The Barbershop</router-link>
          </li>
          
          <li v-show="currentUser == 0">
            <router-link class="nav-elements" v-bind:to="{ name: 'register'}">Register</router-link>
          </li>
          <li v-on:click="toggleBizTech" class="nav-elements">
            Business &amp; Tech<i class="fa fa-light fa-caret-down"></i>
            <div class="dropdown-menu" v-show="showBizTechDropdown">
              <ul>
                <li>
                  <router-link
                    class="dropdown-elements-sports"
                    v-show="showBizTechDropdown"
                    v-bind:to="{ name: 'business'}"
                    v-on:click.stop="logBusinessClick(); showMenu = false; showBizTechDropdown = false; resetScrollDepth()"
                  >Business</router-link>
                </li>
                <li>
                  <router-link
                    class="dropdown-elements-sports"
                    v-show="showBizTechDropdown"
                    v-bind:to="{ name: 'technology'}"
                    v-on:click.stop="logTechnologyClick(); showMenu = false; showBizTechDropdown = false; resetScrollDepth()"
                  >Technology</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li v-on:click="toggleSports" class="nav-elements">
            Sports<i class="fa fa-light fa-caret-down"></i>
            <div class="dropdown-menu" v-show="showSportDropdown">
              <ul>
                <li>
                  <router-link
                    class="dropdown-elements-sports"
                    v-show="showSportDropdown"
                    v-bind:to="{ name: 'yourSports'}"
                    v-on:click="showMenu = false; showSportDropdown = false; resetScrollDepth()"
                  >Your Sports</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-sports" v-show="showSportDropdown" v-bind:to="{ name: 'nba'}" v-on:click="logNbaClick(); resetScrollDepth()">NBA</router-link>
                </li>
                <li>
                  <router-link  class="dropdown-elements-sports" v-show="showSportDropdown" v-bind:to="{ name: 'nfl'}" v-on:click="logNflClick(); resetScrollDepth()">NFL</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-sports" v-show="showSportDropdown" v-bind:to="{ name: 'nhl'}" v-on:click="logNhlClick(); resetScrollDepth()">NHL</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-sports" v-show="showSportDropdown" v-bind:to="{ name: 'mma'}" v-on:click="logMmaClick(); resetScrollDepth()">MMA</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li v-on:click="togglePolitics" class="nav-elements">
            Politics<i class="fa fa-light fa-caret-down"></i>
            <div class="dropdown-menu" v-show="showPoliticsDropdown">
              <ul>
                <li>
                  <router-link class="dropdown-elements-politics" v-show="showPoliticsDropdown" v-bind:to="{ name: 'right-wing'}" v-on:click="logRightClick(); resetScrollDepth()">Right Wing</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-politics" v-show="showPoliticsDropdown" v-bind:to="{ name: 'left-wing'}" v-on:click="logLeftClick(); resetScrollDepth()">Left Wing</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-politics" v-show="showPoliticsDropdown" v-bind:to="{ name: 'center'}" v-on:click="logCenterClick(); resetScrollDepth()">Center</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li v-on:click="toggleEntertainment" class="nav-elements">
            Entertainment<i class="fa fa-light fa-caret-down"></i>
            <div class="dropdown-menu" v-show="showEntertainmentDropdown">
              <ul>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showEntertainmentDropdown" v-bind:to="{ name: 'inTheaters'}" v-on:click="logMovieClick(); resetScrollDepth()">In Theaters</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showEntertainmentDropdown" v-bind:to="{ name: 'movies'}" v-on:click="logMovieClick(); resetScrollDepth()">Movies</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showEntertainmentDropdown" v-bind:to="{ name: 'television'}" v-on:click="logTvClick(); resetScrollDepth()">Television</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showEntertainmentDropdown" v-bind:to="{ name: 'music'}" v-on:click="logMusicClick(); resetScrollDepth()">Music</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <router-link class="nav-elements" v-bind:to="{ name: 'newsletterPage'}">The Daily cut</router-link>
          </li>
          <li v-on:click="toggleAbout" class="nav-elements">
            About<i class="fa fa-light fa-caret-down"></i>
            <div class="dropdown-menu" v-show="showAboutDropdown">
              <ul>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'aboutPage'}">About Us</router-link>
                </li>
                <li>
                  <button
                    type="button"
                    class="dropdown-elements-entertainment dropdown-elements-entertainment--button"
                    v-show="showAboutDropdown"
                    @click.stop="openExploreTutorial"
                  >
                    Explore BarbershopTalk
                  </button>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'underSniperPage'}">The Under Sniper</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'methodologyPage'}">Methodology</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'howSentimentWorksPage'}">How Sentiment Works</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'howBiasWorksPage'}">How Bias Analysis Works</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'howBlindspotWorksPage'}">How Blindspots Work</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'challengeYourViewPage'}">Challenge Your View</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'editorialPolicyPage'}">Editorial Policy</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'communityGuidelinesPage'}">Community Guidelines</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'privacyPolicyPage'}">Privacy Policy</router-link>
                </li>
                <li>
                  <router-link class="dropdown-elements-entertainment" v-show="showAboutDropdown" v-bind:to="{ name: 'termsOfServicePage'}">Terms of Service</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li v-show="!token">
            <router-link class="nav-elements" v-bind:to="{ name: 'login'}">Login</router-link>
          </li>
          <li v-show="token">
            <router-link class="nav-elements" v-bind:to="{ name: 'profilePage'}">Profile</router-link>
          </li>
          <li v-show="token">
            <router-link
              class="nav-elements"
              v-bind:to="{ name: 'accountSettings'}"
              v-on:click="showMenu = false; resetScrollDepth()"
            >Settings</router-link>
          </li>
          <li v-show="token">
            <router-link class="nav-elements" v-bind:to="{ name: 'logout' }">Logout</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import LoggerService from '@/services/LoggerService';
import ArticleDataService from '@/services/ArticleDataService';
import { replayFromHelp } from '@/composables/useTutorialProgress';

export default {

    name: "MobileNavbar",
    components: {
    },
    data(){
        return {
            currentUser: 0,
            showSportDropdown: false,
            showEntertainmentDropdown: false,
            showPoliticsDropdown: false,
            showAboutDropdown: false,
            showBizTechDropdown: false,
            showMenu: false,
        }
    },
    created(){
        //calls for current user
        ArticleDataService.getUser().then(response => {
          this.currentUser = response.data
    })
    },
    methods:{
      resetScrollDepth(){
        this.$store.state.scrollDepth = null;
      },
      openExploreTutorial(){
        this.showMenu = false;
        this.showAboutDropdown = false;
        replayFromHelp();
      },
        toggleSports(){
            if(this.showSportDropdown == true){
            this.showSportDropdown = false;
            } else {
                this.showSportDropdown = true;
            }
        },
        toggleBizTech(){
            if(this.showBizTechDropdown == true){
            this.showBizTechDropdown = false;
            } else {
                this.showBizTechDropdown = true;
            }
        },
        toggleEntertainment(){
            if(this.showEntertainmentDropdown == true){
            this.showEntertainmentDropdown = false;
            } else {
                this.showEntertainmentDropdown = true;
            }
        },
        togglePolitics(){
            if(this.showPoliticsDropdown == true){
            this.showPoliticsDropdown = false;
            } else {
                this.showPoliticsDropdown = true;
            }
        },
        toggleAbout(){
            if(this.showAboutDropdown == true){
            this.showAboutDropdown = false;
            } else {
                this.showAboutDropdown = true;
            }
        },
        logBusinessClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:business`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('business logged')
            } else {
              console.log('not working')
            }
          })
      },
      logTechnologyClick(){
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:technology`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('technology logged')
            } else {
              console.log('not working')
            }
          })
      },
      logNbaClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:nba`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('nba logged')
            } else {
              console.log('not working')
            }
          })
      },
      logNflClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:nfl`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('nfl logged')
            } else {
              console.log('not working')
            }
          })
      },
      logNhlClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:nhl`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('nhl logged')
            } else {
              console.log('not working')
            }
          })
      },
      logMmaClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:mma`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('mma logged')
            } else {
              console.log('not working')
            }
          })
      },
      logPoliticsClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:politics`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('pol logged')
            } else {
              console.log('not working')
            }
          })
      },
      logRightClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:right_wing`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('right logged')
            } else {
              console.log('not working')
            }
          })
      },
      logLeftClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:left_wing`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('left logged')
            } else {
              console.log('not working')
            }
          })
      },
      logCenterClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:left_wing`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('Center logged')
            } else {
              console.log('not working')
            }
          })
      },
      logMovieClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:movies`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('movie logged')
            } else {
              console.log('not working')
            }
          })
      },
      logMusicClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:music`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('music logged')
            } else {
              console.log('not working')
            }
          })
      },
      logTvClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:television`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('tv logged')
            } else {
              console.log('not working')
            }
          })
      },
    },
    mounted() {
  console.log('Is Safari:', this.isSafari);
  console.log('Is Safari Login Page:', this.isSafariLoginPage);
  console.log('User Agent:', navigator.userAgent);
},
    computed: {
          token() {
            return this.$store.state.token;
          },
          isSafari() {
    const userAgent = navigator.userAgent;
    return /safari/i.test(userAgent) && !/chrome/i.test(userAgent);
  },
    isSafariLoginPage() {
      return this.isSafari && this.$route.path.includes('/login'); 
    },
    isSafariTrendingPage() {
      return this.isSafari && this.$route.path.includes('/trending'); 
    }
  }
}
</script>

<style scoped>
/* HTML TAG ELEMENTS */

.nav-logo img {
    height: var(--bst-mobile-nav-content);
    width: auto;
    max-width: 180px;
    display: block;
    margin-bottom: 0px;
    margin-top: 0px;
}
 ul {
  padding: 0px;
 }

li {
    list-style: none;
}

.nav-bell{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    padding-top: 50px;
    padding-left: 20px;
    padding-right: 14px;
    color: white;
    height: 80%;
    font-weight: 900;
    z-index: 3;
    cursor: pointer;
}

router-link {
    text-decoration: none;
}
/* NAV BAR */

.nav-logo{
    padding: 0px;
    margin: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.main-div{
    display: flex;
    flex-direction: column;
    width: 100%;
}

/* @supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none) {
  .menu-items {
    
    margin-top: 0 !important; 
  }
} */

.menu-items{
    top: var(--bst-mobile-nav-offset);
    position: fixed;
    width: 100%;
    left: 0;
    background-color: #dd3434;
    transform: translateY(-100%);
    transition: transform 0.8s ease-out;
    max-height: calc(100dvh - var(--bst-mobile-nav-offset));
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    z-index: 1250;
}

  .safari-fix {
    margin-top: 0; 
  }


.burger-bell{
  display: flex;
  flex-direction: column;
}
/* mobile responsiveness */
menu-items{
  align-self: start;
}

.hamburger-button{
    display: none;
}
.nav-container{
  background: #3b9aed;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: content-box;
  width: 100%;
  z-index: 1300;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--bst-mobile-nav-content);
  padding-top: env(safe-area-inset-top, 0px);
  padding-bottom: 0;
  transition: all 0.5s ease;
}
.nav-main{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10vh;
    margin-left: 0px;
    padding: 0%;
    z-index: 1;  
}
.nav-elements{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    flex-direction: column;
    padding-top: 27px;
    padding-left: 20px;
    padding-right: 20px;
    color: white;
    border-top: .5px solid white;
    height: 80%;
    font-family: 'Titillium Web', sans-serif;
    font-size: large;
    font-weight: 900;
    z-index: 3;
    -webkit-transition: background-color .5s;
    -moz-transition:    background-color .5s;
    -ms-transition:     background-color .5s;
    -o-transition:      background-color .5s;
    transition:         background-color .5s;
}


.nav-elements:hover{
    background-color: #dd3434;
}

.dropdown-menu{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-decoration: none;
    z-index: 100;
    position: relative;
    top: 100%;
    text-align: left;
    opacity: 1;
    visibility: visible;
    transition: all 0.5s ease-in-out;
    height: max-content;
    
}

.dropdown-menu ul li {
  text-align: center;
  border-top: 0.5px solid white; 
  padding: 10px;
}

.dropdown-elements-sports,
.dropdown-elements-entertainment,
.dropdown-elements-politics {
  display: block;
  text-align: center;
  text-decoration: none;
  color: white;
  
  transition: all 0.5s ease-in-out; 
  width: 100%; 
}
.dropdown-elements-entertainment--button {
  appearance: none;
  -webkit-appearance: none;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: block;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.dropdown-elements-sports:focus-visible,
.dropdown-elements-entertainment:focus-visible,
.dropdown-elements-politics:focus-visible {
  outline: 3px solid rgba(255, 255, 255, 0.5);
  outline-offset: -3px;
}




.nav-elements:hover .dropdown-menu {
    transition: all 0.5s ease-in-out;
    opacity: 1;
    visibility: visible;
}

.hamburger-button {
    display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: grey;
  cursor: pointer;
  font-size: 1.5rem;
  position: absolute;
  right: 20px;
  top: env(safe-area-inset-top, 0px);
  height: var(--bst-mobile-nav-content);
}

.hamburger-button-clicked{
    color: white;
}

/* Under Sniper flagship nav: established green, no PRO badge */
.nav-elements--picks {
    background: rgba(16, 185, 129, 0.18);
    border-left: 3px solid #10b981;
}
.nav-picks-row {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}
.nav-picks-row i {
    color: #6ee7b7;
}


</style>